<template>
    <div>
        <Popup v-model="popupShow" closeable close-icon-position="top-right" @close="close" style="width: 90%">
            <NavBar title="开始处理"/>
            <CellGroup>
                <Cell required title="状态"/>
                <Cell>
                    <RadioGroup v-model="detail.state" direction="horizontal" style="justify-content: center">
                        <Radio name="NORMAL">正常</Radio>
                        <Radio name="ERROR">异常</Radio>
                    </RadioGroup>
                </Cell>
                <span style="color:red;margin:5px">*</span>&nbsp;
                <div style="display:flex;justify-content : space-between;width:95%;margin:auto;">
                    <UploadImage
                            :imageList="image1"
                            style="margin-top:5px;margin-left:-15px"
                            top="打卡照片1"
                            type="SafetyImage"
                            :count="1"
                            @imageChange="image1Change"
                            edit
                    />
                    <UploadImage
                            :imageList="image2"
                            style="margin-top:5px;margin-left:-15px"
                            top="打卡照片2"
                            type="SafetyImage"
                            :count="1"
                            @imageChange="image2Change"
                            edit
                    />
                    <UploadImage
                            :imageList="image3"
                            style="margin-top:5px;margin-left:-15px"
                            top="打卡照片3"
                            type="SafetyImage"
                            :count="1"
                            @imageChange="image3Change"
                            edit
                    />
                    <UploadImage
                            :imageList="image4"
                            style="margin-top:5px;margin-left:-15px"
                            top="打卡照片4"
                            type="SafetyImage"
                            :count="1"
                            @imageChange="image4Change"
                            edit
                    />
                </div>
                <Cell icon="location" title="当前位置">
                    <Button @click="refresh" size="small" block type="info" style="width:15%;">刷新</Button>
                </Cell>
                <Cell :value="position.address"/>
            </CellGroup>
            <pf code="SAFETY_TASK_HANDLE">
                <Button type="info" block style="width: 90% ; margin: 10px auto;" @click="submit">确定</Button>
            </pf>
        </Popup>
    </div>
</template>

<script>
    import {RadioGroup, Radio, CellGroup, Cell, Popup, Form, Field, Button, NavBar} from "vant"
    import UploadImage from "@/components/UploadImage";
    import {mapGetters} from "vuex";

    export default {
        components: {UploadImage, RadioGroup, Radio, CellGroup, Cell, Popup, Form, Field, Button, NavBar},
        props: {
            taskDetail: {type: Object, required: true},
            type: {type: String, default: "default"},
            show: {type: Boolean, default: false}
        },
        data() {
            return {
                popupShow: false,
                mapPanel: false,
                detail:{
                    state:'NORMAL'
                }
            }
        },
        computed: {
            ...mapGetters({position: 'wechat/position'}),
            image1() {
                return this.detail.image1 ? [this.detail.image1] : []
            },
            image2() {
                return this.detail.image2 ? [this.detail.image2] : []
            },
            image3() {
                return this.detail.image3 ? [this.detail.image3] : []
            },
            image4() {
                return this.detail.image4 ? [this.detail.image4] : []
            },
        },
        created(){},
        mounted() {
        },
        methods: {
            refresh() {
             const position=   this.$store.dispatch({type: 'wechat/getLocation'});
            },
            submit() {

                this.$toast.loading("正在处理中...")
                this.$http.tokiot.safety.task.position.submit({
                    id: this.detail.id,
                    subAddress: this.position.address,
                    subLat: this.position.latitude,
                    subLng: this.position.longitude,
                    state: this.detail.state,
                    image1: this.detail.image1,
                    image2: this.detail.image2,
                    image3: this.detail.image3,
                    image4: this.detail.image4
                }).then(res => {
                    if (res) {
                        this.$toast.success("打卡成功")
                        this.popupShow = !this.popupShow
                        this.$emit("onRefresh")
                    } else {
                        this.$toast.fail(res.message)
                    }
                })
            },

            image1Change(imageList) {
                this.detail.image1 = imageList[0];
            },
            image2Change(imageList) {
                this.detail.image2 = imageList[0];
            },
            image3Change(imageList) {
                this.detail.image3 = imageList[0];
            },
            image4Change(imageList) {
                this.detail.image4 = imageList[0];
            },
            close() {
                this.$emit('panel', this.type,)
            },
        },
        watch: {
            show(show) {
                this.popupShow = show
            },
            taskDetail(detail){
                this.detail=detail
            }
        }
    }
</script>

<style scoped>

</style>